"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.update = exports.create = exports.search = exports.fetch = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const contactPersonService_1 = require("./service/contactPersonService");
const Env_1 = require("../../utils/tsUtils/Env");
exports.fetch = (0, toolkit_1.createAsyncThunk)('contactPerson/fetch', (fetchPayLoad, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const contactPersonService = new contactPersonService_1.ContactPersonService(Env_1.APIPATHENV);
        const response = yield contactPersonService.fetch(fetchPayLoad);
        return response;
    }
    catch (err) {
        throw new Error("Failed to fetch");
    }
}));
exports.search = (0, toolkit_1.createAsyncThunk)('contactPerson/search', (query, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const contactPersonService = new contactPersonService_1.ContactPersonService(Env_1.APIPATHENV);
        const response = yield contactPersonService.search(query);
        return response;
    }
    catch (err) {
        throw new Error("Failed to search");
    }
}));
exports.create = (0, toolkit_1.createAsyncThunk)('contactPerson/create', (createPayload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const contactPersonService = new contactPersonService_1.ContactPersonService(Env_1.APIPATHENV);
        const response = yield contactPersonService.create(createPayload);
        return response;
    }
    catch (err) {
        throw new Error(err.response.data.message);
    }
}));
exports.update = (0, toolkit_1.createAsyncThunk)('contactPerson/update', (createPayload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const contactPersonService = new contactPersonService_1.ContactPersonService(Env_1.APIPATHENV);
        const response = yield contactPersonService.update(createPayload);
        return response;
    }
    catch (err) {
        throw new Error(err.response.data.message);
    }
}));
